module.exports = {
  baseUrl: './',
  projectName: 'BIQS'
}
